import TextField from 'components/common/TextField'
import Button from 'components/Button'
import {
  CollectiveProposal,
  useCancelProposalMutation
} from 'graphql/generated'
import { useControlledInput, useQueryErrorHandler } from 'hooks'
import BaseModal from 'components/modals/BaseModal'

type TProposal = Pick<CollectiveProposal, 'id' | 'title'>

export function CancelProposalModal({
  proposal,
  onClose
}: {
  proposal: TProposal
  onClose: Callback
}) {
  const [reason, setReason] = useControlledInput('')

  const onError = useQueryErrorHandler(`Failed to cancel Proposal`)
  const [cancelProposal, { loading }] = useCancelProposalMutation({
    variables: {
      proposalId: proposal.id,
      reason
    },
    onError,
    onCompleted: onClose
  })

  return (
    <BaseModal onClose={onClose}>
      <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div className="mt-3 text-center sm:mt-0 sm:ml-4 md:ml-0 sm:text-left">
          <h3
            className="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            {`Cancel Proposal \u00b7 ${proposal.title}`}
          </h3>

          <div className="pt-6">
            <TextField
              label={`Why're you canceling this proposal?`}
              multiple
              minRows={4}
              value={reason}
              onChange={setReason}
              disabled={loading}
              horizantalFullWidth
            />
          </div>
        </div>
      </div>

      <div className="bg-gray-50 py-4 px-6 flex space-x-2 justify-end">
        <Button onClick={onClose} color="outline" label={`Dismiss`} />

        <Button
          color="blue"
          onClick={() => cancelProposal()}
          disabled={loading}
          label={`Cancel Proposal`}
        />
      </div>
    </BaseModal>
  )
}
